<h1 mat-dialog-title>{{projectName ? ('project.EditProjectPerson' | translate) : ('project.NewProjectPerson' | translate)}}</h1>
<div mat-dialog-content>
  <app-projectperson-editor #projectEditor [projectPerson]="data.projectperson" [projectNumber]="data.projectNumber"></app-projectperson-editor>
</div>
<div mat-dialog-actions>
  <button  mat-raised-button (click)="projectEditor.save();" [disabled]="!projectEditor.form.dirty" color="primary"> {{'common.Save' | translate}}</button>
  <button  mat-raised-button (click)="cancel()" color="warn"> {{'common.Cancel' | translate}}</button>
</div>
